module.exports = __webpack_public_path__ + "public/images/learning-with-minecraft.c820560a81f238c9ab0e835c68910855.jpg";